import {Component, CUSTOM_ELEMENTS_SCHEMA, inject, input, OnInit, signal} from '@angular/core';
import {NotificationDto} from '../../../dto/notification-dto';
import {TimeAgoPipe} from '../../../pipe/time-ago-pipe';
import {Avatar} from '../../shared/avatar/avatar';
import {RouteBuilder} from '../../../service/route-builder';
import {RouterLink} from '@angular/router';
import {SelectSectorService} from '../../../service/sector-selection';
import {User} from '../../../service/user';
import {Pop} from '../../../service/pop';
import {Pm} from '../../../service/pm';

@Component({
  selector: 'app-notification-item',
  templateUrl: './notification-item.html',
  styleUrl: './notification-item.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    TimeAgoPipe,
    Avatar,
    RouterLink,
  ]
})
export class NotificationItem implements OnInit {

  notification = input.required<NotificationDto>();
  protected resolvedContext = signal<any>(null);

  protected readonly selectSectorService = inject(SelectSectorService);
  private readonly userService = inject(User);
  private readonly popService = inject(Pop);
  private readonly pmService = inject(Pm);

  constructor(protected readonly routeBuilder: RouteBuilder) {
  }

  ngOnInit() {
    const context = this.notification().context;
    if (!context) return;

    const popId = this.getContextValue(context, 'popId');
    const pmId = this.getContextValue(context, 'pmId');
    const userId = this.getContextValue(context, 'userId');
    if (!popId && !pmId && !userId) {
      this.setContext();
      return;
    }

    if (popId) {
      this.retrievePopById(popId + "");
    } else if (pmId) {
      this.retrievePmById(pmId + "");
    } else if (userId) {
      this.retrieveUserByKeycloakId(userId + "");
    }
  }

  private getContextValue(context: any, key: string): any {
    return context instanceof Map ? context.get(key) : context[key];
  }

  private retrievePopById(popId: string) {
    this.popService.retrievePopById(popId, ['id', 'employeeId']).subscribe({
      next: (pop) => {
        this.retrieveUserByKeycloakId(pop.employeeId);
      },
      error: () => this.setContext()
    });
  }

  private retrievePmById(pmId: string) {
    this.pmService.retrievePmById(pmId, ['id', 'employeeId']).subscribe({
      next: (pm) => {
        this.retrieveUserByKeycloakId(pm.employeeId!);
      },
      error: () => this.setContext()
    });
  }

  private retrieveUserByKeycloakId(employeeId: string) {
    this.userService.retrieveUserByKeycloakId(employeeId, ['id']).subscribe({
      next: (user) => this.setContext({userId: user.id}),
      error: () => this.setContext()
    });
  }

  private setContext(extra: object = {}) {
    const context = this.notification().context;

    if (!context) return;

    const contextObject = context instanceof Map ? Object.fromEntries(context) : context;
    const {userId, ...contextWithoutUserId} = contextObject;

    this.resolvedContext.set({
      ...contextWithoutUserId,
      ...extra,
      sectorId: this.getContextValue(context, 'sectorId') ?? this.selectSectorService.getSelectedSectorId()
    });
  };
}
